import Requests from '@/services/request';
import { getQueryStringArgs, queryStringify } from '@/utils/url-parse';
import './index.less';

import $i18n from '../../i18n';

function LocaleSwitch() {
  const changeLanguage = (v: string) => {
    Requests.get('/rest/intercnn/changeLanguage', { lang: v }).then(() => {
      const { origin, pathname, hash } = window.location;
      const { spaceId } = getQueryStringArgs();
      const lang = v === 'zh_CN' ? 'zh-CN' : 'en-US';
      window.location.replace(
        `${origin}${pathname}?lang=${lang}&spaceId=${spaceId || ''}${hash.split('?')?.[0]}?${queryStringify(
          Object.assign({}, getQueryStringArgs() || {}, { lang: lang }),
        )}`,
      );
    });
  };

  return (
    <div className="locale-switch">
      <div
        className={`item ${$i18n.language === 'zh-CN' ? 'active' : ''}`}
        onClick={() => {
          if ($i18n.language !== 'zh-CN') {
            changeLanguage('zh_CN');
          }
        }}
      >
        {$i18n.get({ id: 'aopf.components.LocaleSwitch.ChineseZh', dm: 'ZH' })}
      </div>
      <div className="divider">/</div>
      <div
        className={`item ${$i18n.language === 'en-US' ? 'active' : ''}`}
        onClick={() => {
          if ($i18n.language !== 'en-US') {
            changeLanguage('en_US');
          }
        }}
      >
        {$i18n.get({ id: 'aopf.components.LocaleSwitch.ChineseEn', dm: 'EN' })}
      </div>
    </div>
  );
}

export default LocaleSwitch;
